module.exports = __webpack_public_path__ + "static/pastries1-b69944af23bd1863fe74e6946787b117.jpg";